import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AppRouter from './router';
import { addShopName, setFeedback, saveCurrency, ShowWarning, ShowMessage, saveShopId, saveStatesList, saveCountries, saveCountry, setActivePlan, setFeatures, setHost, setStore, setRemainingTrial } from './store/actions/configActions';
import { saveShippingList, setFetching, setDefaultPrice, saveFreeShippingRule, saveFreeProducts, setShippingCounts } from './store/actions/shippingActions';
import { NavMenu } from '@shopify/app-bridge-react';
import { useLocation, Link } from 'react-router-dom';
import "./App.css"
import useAuthenticatedFetch from './hooks/useAuthenticatedFetch';
import { setTime } from './components/actions';


const App = () => {
  const initialized = useRef(false);
  const { ConfigReducer } = useSelector(state => state)
  const dispatch = useDispatch()
  const location = useLocation()
  const fetchJson = useAuthenticatedFetch()

  useEffect(() => {

    if (Object.keys(ConfigReducer.store).length === 0 && !initialized.current) {
      initialized.current = true;
      getShopDomain()
    }
  }, [ConfigReducer.store])

  const getShopDomain = async () => {
    dispatch(setFetching(true))
    let shop_id
    const search = new URLSearchParams(location.search);

    if (search.get('host') !== '') {
      dispatch(setHost(search.get('host')))
    }

    // const fetchJson = async (url, options = {}) => {
    //   const response = await fetchFunction(url, options)
    //   return response.json()
    // }

    try {
      const list = await fetchJson('/settings/countries')
      dispatch(saveStatesList(list.statesList))
      dispatch(saveCountries(list.countries))


      const shopJson = await fetchJson('/shop', {
        method: 'GET',
        headers: { 'x-access-token': search.get('shop') }
      })

      if (Object.hasOwnProperty.call(shopJson, "shop")) {
        const shop = shopJson.shop
        shop_id = shop.shop_id
        localStorage.setItem("store", JSON.stringify(shop))
        dispatch(setStore(shop))
        dispatch(saveCurrency(shop.shop_currency))
        dispatch(saveShopId(shop.shop_id))
        dispatch(ShowWarning(shop.show_warning))
        dispatch(ShowMessage(shop.show_message))
        dispatch(addShopName(shop.shop_name))
        dispatch(saveCountry({ name: shop.country, code: shop.country_code }))

        setTime(shop.shop_id, fetchJson)
        dispatch(setRemainingTrial(Object.hasOwnProperty.call(shopJson, "remainingTrial") ? shopJson.remainingTrial : shop.trialDays))
      }

      if (Object.hasOwnProperty.call(shopJson, "feedback")) {
        dispatch(setFeedback(shopJson.feedback))
      }

      if (Object.hasOwnProperty.call(shopJson, "activePlan")) {
        const activePlan = shopJson.activePlan
        const featuresList = shopJson.featuresList
        dispatch(setActivePlan(activePlan))
        dispatch(setFeatures(featuresList))

        const countJson = await fetchJson('/shipping/count', {
          method: 'GET',
          headers: { shop_id, 'x-access-token': shop_id }
        })
        if (Object.hasOwnProperty.call(countJson, "totalShippings")) {
          dispatch(setShippingCounts(countJson.totalShippings))
          // dispatch(saveShippingList(r.shippingData))
        }
        dispatch(setFetching(false))
        const priceJson = await fetchJson('/settings/price', {
          method: 'GET',
          headers: { shop_id, 'x-access-token': shop_id }
        })
        if (Object.hasOwnProperty.call(priceJson, "price")) {
          dispatch(setDefaultPrice(priceJson.price))
        }

        const freeShippingJson = await fetchJson('/settings/free-shipping', {
          method: 'GET',
          headers: { shop_id, 'x-access-token': shop_id }
        })
        if (Object.hasOwnProperty.call(freeShippingJson, "price")) {
          dispatch(saveFreeShippingRule(freeShippingJson.price))
        }

        const productsJson = await fetchJson('/settings/free_products', {
          method: 'GET',
          headers: { shop_id, 'x-access-token': shop_id }
        })
        if (Object.hasOwnProperty.call(productsJson, "products")) {
          dispatch(saveFreeProducts(productsJson.products))
        }
      }
    } catch (e) {
      console.log("getShopDomain", e.message);
      // dispatch(setToast({ active: true, content: e.message + " Catch", error: true }))
    } finally {
      dispatch(setFetching(false))
    }
  }
  const regexp = /^\/moreapps\/.+$/;
  const moreapps = regexp.test(location.pathname);
  return (
    <div>
      {(!moreapps && ConfigReducer.store.plan_id) ? <NavMenu>
        <Link to="/" rel="home">Home</Link>
        <Link to="/rates">Shipping Rates</Link>
        <Link to="/free_shipping_rules">Free Shipping Rules</Link>
        <Link to="/default-price">Fallback Rate</Link>
        <Link to="/tutorials">Tutorials</Link>
        <Link to="/apps">More Apps</Link>
      </NavMenu> : null}
      <AppRouter scopes={null} />
    </div>
  )
}

export default App
